module.exports = __webpack_public_path__ + "img/Benjamin Buding.daa8e3fd.jpg";